<header class="dialog-tarefa__cabecalho" mat-dialog-title>
  <button mat-icon-button type="button" aria-label="Fechar" (click)="cancelar()"><mat-icon>close</mat-icon></button>
</header>

<div class="dialog-tarefa__conteudo" mat-dialog-content>
  <main class="dialog-tarefa__principal">
    <section class="dialog-tarefa__titulo-cartao"><input [(ngModel)]="data.cartao.noCartao" maxlength="200"
        aria-label="Título da tarefa"></section>

    <section class="dialog-tarefa__secao">
      <div class="dialog-tarefa__secao-titulo"><mat-icon>format_align_left</mat-icon>
        <h2>Descrição</h2>
      </div>
      <textarea class="dialog-tarefa__descricao" [(ngModel)]="data.cartao.dsCartao" maxlength="4000" rows="3"
        placeholder="Adicione uma descrição mais detalhada..."></textarea>
    </section>

    <div class="dialog-tarefa__linha">
      <mat-form-field appearance="outline"><mat-label>Prioridade</mat-label><mat-select
          [(ngModel)]="data.cartao.noPrioridade"><mat-option [value]="null">Nenhum</mat-option><mat-option
            value="Baixa">Baixa</mat-option><mat-option value="Média">Média</mat-option><mat-option
            value="Alta">Alta</mat-option><mat-option value="Urgente">Urgente</mat-option></mat-select></mat-form-field>
      <mat-form-field appearance="outline"><mat-label>Vencimento</mat-label><input matInput type="date"
          [(ngModel)]="data.cartao.dtVencimento"></mat-form-field>
    </div>

    <section class="dialog-tarefa__secao">
      <div class="dialog-tarefa__secao-titulo"><mat-icon>sell</mat-icon>
        <h2>Etiquetas</h2>
      </div>
      <mat-form-field appearance="outline" class="dialog-tarefa__etiquetas"><mat-label>Etiquetas</mat-label><mat-select
          multiple [(ngModel)]="data.cartao.idsEtiquetas"><mat-select-trigger><span class="dialog-tarefa__etiquetas-selecionadas"><span
              *ngFor="let etiqueta of etiquetasSelecionadas()" class="dialog-tarefa__etiqueta-selecionada"
              [style.background]="etiqueta.noCor" [style.color]="corTextoEtiqueta(etiqueta.noCor)">{{ etiqueta.noEtiqueta }}</span></span></mat-select-trigger><mat-option *ngFor="let etiqueta of data.etiquetas"
            [value]="etiqueta.id"><span class="dialog-tarefa__etiqueta-opcao" [style.background]="etiqueta.noCor"
              [style.color]="corTextoEtiqueta(etiqueta.noCor)">{{ etiqueta.noEtiqueta }}</span></mat-option></mat-select><button
          mat-icon-button matSuffix type="button" matTooltip="Nova etiqueta" aria-label="Nova etiqueta"
          (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation(); adicionarEtiqueta()"><mat-icon>add</mat-icon></button></mat-form-field>
    </section>

    <section class="dialog-tarefa__secao">
      <div class="dialog-tarefa__secao-titulo"><mat-icon>checklist</mat-icon>
        <h2>Checklist</h2><button mat-button type="button" (click)="adicionarChecklist()">Adicionar item</button>
      </div>
      <div class="dialog-tarefa__checklists">
        <div class="dialog-tarefa__checklist" *ngFor="let item of data.cartao.checklists; let indice = index">
          <mat-checkbox color="primary" [(ngModel)]="item.blConcluido"></mat-checkbox>
          <input [(ngModel)]="item.dsItem" maxlength="500" placeholder="Descrição do item" required>
          <button mat-icon-button type="button" aria-label="Remover item"
            (click)="removerChecklist(indice)"><mat-icon>close</mat-icon></button>
        </div>
      </div>
    </section>
  </main>

  <aside class="dialog-tarefa__atividade">
    <h2><mat-icon>chat_bubble_outline</mat-icon>Comentários e atividade</h2>
    <section class="dialog-tarefa__novo-comentario">
      <textarea [(ngModel)]="novoComentario" maxlength="2000" rows="3" placeholder="Escreva um comentário..."
        [readonly]="enviandoComentario" (keydown.control.enter)="adicionarComentario()"></textarea>
      <button mat-raised-button color="primary" type="button" [disabled]="enviandoComentario || !novoComentario.trim()"
        (click)="adicionarComentario()">Comentar</button>
    </section>
    <article class="dialog-tarefa__comentario" *ngFor="let comentario of data.cartao.comentarios">
      <strong>{{ comentario.noNomeUsuario || 'Usuário' }}</strong><p>{{ comentario.dsComentario }}</p><small>{{ comentario.dtCriacao | date:'dd/MM/yyyy HH:mm' }}</small>
    </article>
    <div class="dialog-tarefa__historico" *ngFor="let historico of data.cartao.historicos"><mat-icon>history</mat-icon>
      <div><strong>{{ historico.noEvento }}</strong><span>{{ historico.dsEvento }}</span><small>{{ historico.dtEvento |
          date:'dd/MM/yyyy HH:mm' }}</small></div>
    </div>
    <p class="dialog-tarefa__sem-historico" *ngIf="!data.cartao.historicos.length">Nenhuma atividade registrada.</p>
  </aside>
</div>

<div class="dialog-tarefa__acoes" mat-dialog-actions>
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-stroked-button color="warn" type="button" (click)="arquivar()">Arquivar</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!data.cartao.noCartao.trim() || possuiChecklistInvalido()"
    (click)="salvar()">Salvar</button>
</div>
